// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"193":"d556de20334ae19e","529":"3d3ae185c7b9c513","864":"f7edb87b32ce946f"}[chunkId] + ".css";
};